import * as ActionTypes from './actionTypes'
import { EDIT_MODES } from '../constants'

const defaultBuffer = { layerId: -1, distance: 1, unit: 'feet' }
const defaultEditMode = EDIT_MODES.NEW

export const openEditor = (buffer = defaultBuffer, mode = defaultEditMode) => ({
  type: ActionTypes.OPEN_EDITOR,
  buffer,
  mode
})
export const closeEditor = () => ({ type: ActionTypes.CLOSE_EDITOR })

export const setEditLayer = layerId => ({
  type: ActionTypes.SET_EDIT_LAYER,
  layerId
})

export const setEditDistance = distance => ({
  type: ActionTypes.SET_EDIT_DISTANCE,
  distance
})

export const setEditUnit = unit => ({
  type: ActionTypes.SET_EDIT_UNIT,
  unit
})

export const editBuffer = buffer => ({
  type: ActionTypes.SAVE,
  buffer
})

export const addBuffer = buffer => ({
  type: ActionTypes.CREATE,
  buffer
})

export const removeBuffer = layerId => ({
  type: ActionTypes.REMOVE,
  layerId
})

export const markBuffersClean = () => ({
  type: ActionTypes.MARK_CLEAN
})

export const fetchStart = () => ({
  type: ActionTypes.FETCH_START
})
export const fetchSuccess = buffers => ({
  type: ActionTypes.FETCH_SUCCESS,
  buffers
})
export const fetchFail = error => ({
  type: ActionTypes.FETCH_FAILURE,
  error
})

export const selectBuffer = layerId => ({
  type: ActionTypes.SELECT,
  layerId
})
export const deselectBuffer = layerId => ({
  type: ActionTypes.DESELECT,
  layerId
})
export const showBuffer = layerId => ({
  type: ActionTypes.SHOW,
  layerId
})
export const hideBuffer = layerId => ({
  type: ActionTypes.HIDE,
  layerId
})

export const hoverStart = layerId => ({ type: ActionTypes.HOVER, layerId })
export const hoverEnd = layerId => ({
  type: ActionTypes.END_HOVER,
  layerId
})
